import React, { Component } from "react";
import { connect } from "react-redux";
import MediaQuery from "react-responsive";

import "airbnb-js-shims";
import axios from "axios";
import Client from "shopify-buy";

import Canvas from "./components/Canvas";
import DatePicker from "./components/DatePicker";
import Location from "./components/Location";
import Theme from "./components/Theme";
import ThemeOptions from "./components/ThemeOptions";
import Text from "./components/Text";
import Sizes from "./components/PrintSize";
import Options from "./components/Options";
import EmailModal from "./components/EmailModal";

import loader from "./assets/loader.gif";
import CanvasActions from "./actions/CanvasActions.js";

let filename, singedUrl;

const client = Client.buildClient({
  domain: "reliefcosmetics.myshopify.com",
  storefrontAccessToken: "7f9af591808eb6911c3f9a36fcebb990"
});
class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      mobile: window.innerWidth < 769,
      toggleBar: false,
      uploaded: false,
      uploading: false,
      moveOnUpload: false,
      number: null,
      optionWrapperWidth: "auto"
    };

    this.optionWrappper = React.createRef();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }
  componentWillMount() {
    client.product.fetchAll().then(products => {
      this.props.setCanvas({
        products: products[0].variants
      });
    });
  }
  async componentDidMount() {
    if (this.optionWrappper.current) {
      this.setState({
        optionWrapperWidth: this.optionWrappper.current.offsetWidth
      });
    }
    window.addEventListener("resize", this.updateDimensions.bind(this));

    filename = +new Date();
    singedUrl = await axios.get(
      `https://5vjk67b3e1.execute-api.us-east-1.amazonaws.com/production/upload`,
      {
        params: {
          filename: filename + ".png",
          filetype: "image/png"
        }
      }
    );

    window.test = () => {
      axios
        .post("https://starmapped.com/cart/add.js", {
          quantity: 1,
          id: 18082985508979
        })
        .then(function(response) {
          console.log(response);
        })
        .catch(function(error) {
          console.log(error);
        });
    };
  }

  updateDimensions() {
    if (this.optionWrappper.current) {
      this.setState({
        optionWrapperWidth: this.optionWrappper.current.offsetWidth
      });
    }
  }

  async upload() {
    if (this.state.uploading) {
      return;
    }

    this.setState({
      uploading: true
    });

    this.props.setCanvas({
      cartLoading: false,
      file: filename,
      showEmailModal: true
    });

    function dataURItoBlob(dataURI) {
      var binary = atob(dataURI.split(",")[1]);
      var array = [];
      for (var i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
      }
      return new Blob([new Uint8Array(array)], { type: "image/png" });
    }

    let image = document.getElementById("print").toDataURL();
    let file = dataURItoBlob(image);

    file.name = filename;

    let _this = this;

    let upload = await axios.put(singedUrl.data, file, {
      headers: { "Content-Type": "multipart/form-data" }
    });

    this.setState({ uploading: false });

    this.checkout();

    // .then(result => {
    //   var signedUrl = result.data;

    //   var options = {
    //     // headers: {
    //     //   "Content-Type": file.type
    //     // }
    //   };

    //   axios.put(signedUrl, file, {}).then(result => {
    //     debugger;
    //     this.setState({ uploading: false });
    //     this.checkout();
    //   });
    // })
    // .catch(function(err) {
    //   console.log(err);
    // });
  }

  async checkout(number) {
    window.fbq("track", "AddToCart");
    if (number) {
      this.setState({ number });
    }

    if (this.state.uploading) {
      this.setState({ moveOnUpload: true });
      this.props.setCanvas({
        cartLoading: true
      });
      return;
    }

    let location = "";
    let file = {
      name: this.props.canvas.file
    };

    if (!number) {
      number = this.state.number;
    }

    // console.log(cart);
    // debugger;

    if (!number) {
      number = 1;
    }

    let checkout = await client.checkout.create();
    let lineitems = [];

    console.log(checkout);

    if (this.props.nonUS) {
      // if (this.props.printSize == 1) {
      //   location = `https://reliefcosmetics.myshopify.com/cart/add?id=18082985508979&quantity=${number}&attributes[printId]=https://s3.amazonaws.com/starmap-uploads/${
      //     file.name
      //   }.png&attributes[Location]=${
      //     this.props.canvas.locationText
      //   }&attributes[Date]=${this.props.canvas.timeDate}&attributes[Message]=${
      //     this.props.canvas.message
      //   }&attributes[Title]=${this.props.canvas.title}`;
      // } else if (this.props.printSize == 2) {
      //   location = `https://reliefcosmetics.myshopify.com/cart/add?id=18082985443443&quantity=${number}&attributes[printId]=https://s3.amazonaws.com/starmap-uploads/${
      //     file.name
      //   }.png&attributes[Location]=${
      //     this.props.canvas.locationText
      //   }&attributes[Date]=${this.props.canvas.timeDate}&attributes[Message]=${
      //     this.props.canvas.message
      //   }&attributes[Title]=${this.props.canvas.title}`;
      // }
    } else if (!this.props.nonUS) {
      // if (this.props.printSize == 1) {
      //   if (this.props.frameAdded) {
      //     lineitems.push({
      //       variantId: this.props.canvas.products[2].id,
      //       quantity: number
      //     });
      //   } else {
      //     lineitems.push({
      //       variantId: this.props.canvas.products[3].id,
      //       quantity: number
      //     });
      //   }
      // }

      // if (this.props.printSize == 2) {
      //   if (this.props.frameAdded) {
      //     lineitems.push({
      //       variantId: this.props.canvas.products[0].id,
      //       quantity: number
      //     });
      //   } else {
      //     lineitems.push({
      //       variantId: this.props.canvas.products[1].id,
      //       quantity: number
      //     });
      //   }
      // }

      // await client.checkout.addLineItems(checkout.id, lineitems);

      // client.checkout
      //   .updateAttributes(checkout.id, {
      //     customAttributes: [
      //       {
      //         key: "printId",
      //         value: `https://s3.amazonaws.com/starmap-uploads/${file.name}.png`
      //       },
      //       {
      //         key: "Location",
      //         value: this.props.canvas.locationText
      //       },
      //       {
      //         key: "Date",
      //         value: this.props.canvas.timeDate
      //       },
      //       {
      //         key: "Message",
      //         value: this.props.canvas.message
      //       },
      //       {
      //         key: "Title",
      //         value: this.props.canvas.title
      //       }
      //     ]
      //   })
      //   .then(checkout => {
      //     window.location.href = checkout.webUrl;
      //   });

      if (this.props.printSize == 1) {
        if (this.props.frameAdded) {
          location = `https://reliefcosmetics.myshopify.com/cart/add?id=18082985476211&quantity=${number}&attributes[printUrl]=https://s3.amazonaws.com/starmap-uploads/${
            file.name
          }.png&attributes[Location]=${
            this.props.canvas.locationText
          }&attributes[Date]=${
            this.props.canvas.timeDate
          }&attributes[Message]=${
            this.props.canvas.message
          }&attributes[Title]=${this.props.canvas.title}&attributes[printId]=${
            file.name
          }.png`;
        } else {
          location = `https://reliefcosmetics.myshopify.com/cart/add?id=18082985508979&quantity=${number}&attributes[printUrl]=https://s3.amazonaws.com/starmap-uploads/${
            file.name
          }.png&attributes[Location]=${
            this.props.canvas.locationText
          }&attributes[Date]=${
            this.props.canvas.timeDate
          }&attributes[Message]=${
            this.props.canvas.message
          }&attributes[Title]=${this.props.canvas.title}&attributes[printId]=${
            file.name
          }.png`;
        }
      } else if (this.props.printSize == 2) {
        if (this.props.frameAdded) {
          location = `https://reliefcosmetics.myshopify.com/cart/add?id=18078810046579&quantity=${number}&attributes[printUrl]=https://s3.amazonaws.com/starmap-uploads/${
            file.name
          }.png&attributes[Location]=${
            this.props.canvas.locationText
          }&attributes[Date]=${
            this.props.canvas.timeDate
          }&attributes[Message]=${
            this.props.canvas.message
          }&attributes[Title]=${this.props.canvas.title}&attributes[Title]=${
            this.props.canvas.title
          }&attributes[printId]=${file.name}.png`;
        } else {
          location = `https://reliefcosmetics.myshopify.com/cart/add?id=18082985443443&quantity=${number}&attributes[printUrl]=https://s3.amazonaws.com/starmap-uploads/${
            file.name
          }.png&attributes[Location]=${
            this.props.canvas.locationText
          }&attributes[Date]=${
            this.props.canvas.timeDate
          }&attributes[Message]=${
            this.props.canvas.message
          }&attributes[Title]=${this.props.canvas.title}&attributes[printId]=${
            file.name
          }.png`;
        }
      }
    }

    window.location.href = location;
  }

  render() {
    return (
      <div>
        <MediaQuery query="(max-width: 750px)">
          <div className={"app mobile"}>
            {this.props.canvas.showEmailModal && (
              <EmailModal
                checkout={e => {
                  this.checkout(e);
                }}
              />
            )}

            <div className="header">
              <h1>STAR MAPPED</h1>
            </div>
            <Canvas />

            <div
              className={
                this.state.toggleBar ? "bottom-bar hidden" : "bottom-bar"
              }
            >
              <div className="options-wrapper">
                <div
                  className="toggle"
                  onClick={() => {
                    this.setState({ toggleBar: !this.state.toggleBar });
                  }}
                >
                  {this.state.toggleBar ? (
                    <i className="fa fa-chevron-up" />
                  ) : (
                    <i className="fa fa-chevron-down" />
                  )}
                </div>
                {this.state.step == 0 && <Location />}
                {this.state.step == 1 && <DatePicker />}
                {this.state.step == 2 && <Text />}
                {this.state.step == 3 && <Theme />}
                {this.state.step == 4 && <Options />}
                {this.state.step == 5 && <ThemeOptions />}
                {this.state.step == 6 && <Sizes />}
              </div>
              <div className="breadcrumb">
                {this.state.step > 0 && (
                  <div
                    className="prev"
                    onClick={() => {
                      if (this.state.step > 0) {
                        this.setState({
                          step: this.state.step - 1
                        });
                      }
                    }}
                  >
                    <span>Back</span>
                  </div>
                )}

                {this.state.step < 6 && (
                  <div
                    className="next"
                    onClick={() => {
                      if (this.state.step < 6) {
                        this.setState({
                          step: this.state.step + 1
                        });
                      }
                    }}
                  >
                    <span>Next</span>
                  </div>
                )}

                {this.state.step == 6 && (
                  <div
                    className={
                      this.state.loadingCart ? "checkout loading" : "checkout"
                    }
                    onClick={() => {
                      this.upload();
                    }}
                  >
                    <span>
                      <i className="fa fa-shopping-cart" /> Add to Cart
                      {/* {this.props.canvas.printCost +
                        this.props.canvas.frameCost >
                        0 &&
                        ` ${this.props.canvas.nonUS ? "£" : "$"} - ${this.props
                          .canvas.printCost + this.props.canvas.frameCost}`} */}
                    </span>
                    {this.state.loadingCart && <img src={loader} />}
                  </div>
                )}
              </div>
            </div>
          </div>
        </MediaQuery>
        <MediaQuery query="(min-width: 750px)">
          <div className={"app"}>
            {this.props.canvas.showEmailModal && (
              <EmailModal
                checkout={e => {
                  this.checkout(e);
                }}
              />
            )}

            <div className="header">
              <h1>STAR MAPPED</h1>
            </div>
            <div className="body">
              <Canvas />

              <div className="options-wrapper" ref={this.optionWrappper}>
                <Location />
                <DatePicker />
                <Text />
                <Theme />
                <Options />
                <ThemeOptions />
                <Sizes checkout={this.checkout.bind(this)} />
                <div className="breadcrumb">
                  <div
                    className={
                      this.state.loadingCart ? "checkout loading" : "checkout"
                    }
                    style={{
                      width: this.state.optionWrapperWidth
                    }}
                    onClick={() => {
                      this.upload();
                    }}
                  >
                    <span>
                      <i className="fa fa-shopping-cart" /> Add to Cart
                      {this.props.canvas.printCost +
                        this.props.canvas.frameCost >
                        0 &&
                        ` - ${this.props.canvas.nonUS ? "£" : "$"}${this.props
                          .canvas.printCost + this.props.canvas.frameCost}`}
                    </span>
                    {this.state.loadingCart && <img src={loader} />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </MediaQuery>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    image: state.canvas.image,
    nonUS: state.canvas.nonUS,
    printSize: state.canvas.printSize,
    frameAdded: state.canvas.frameAdded,
    canvas: state.canvas
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setCanvas: canvas => {
      dispatch(CanvasActions.setCanvas(canvas));
    }
  };
};

const App = connect(
  mapStateToProps,
  mapDispatchToProps
)(Index);

export default App;



// WEBPACK FOOTER //
// ./src/App.js